import { App } from "@capacitor/app";
import router from "@/router";
import authService from "@/modules/Authentication/service";
import { saveSupportSession } from "@/modules/Authentication/supportSession";
import { isNativeMobileApp } from "./runtime";
import { mobileBrand } from "./brand";

let initialized = false;
let processing = false;

export function parseNativeSupportUrl(value) {
  const scheme = mobileBrand.deepLinkScheme.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const match = String(value || "").match(new RegExp(`^${scheme}:\\/\\/support#([A-Za-z0-9_-]{43})$`));
  return match ? match[1] : null;
}

export async function handleNativeSupportUrl(value) {
  let supportCode = parseNativeSupportUrl(value);
  if (!supportCode || processing) return false;
  processing = true;
  try {
    await router.replace({ path: "/support-access", query: { status: "opening" } }).catch(() => {});
    const session = await authService.exchangeSupportAccess(supportCode);
    supportCode = "";
    if (!session || !session.token || !session.organizationId || !session.expiresAt) throw new Error("Invalid support session");
    saveSupportSession(session);
    await router.replace("/home").catch(() => {});
    return true;
  } catch (error) {
    supportCode = "";
    await router.replace({ path: "/support-access", query: { status: "invalid", attempt: String(Date.now()) } }).catch(() => {});
    return false;
  } finally {
    supportCode = "";
    processing = false;
  }
}

export async function initializeNativeSupportAccess() {
  if (!isNativeMobileApp || initialized) return;
  initialized = true;
  await App.addListener("appUrlOpen", ({ url }) => { handleNativeSupportUrl(url); });
  const launch = await App.getLaunchUrl().catch(() => null);
  if (launch && launch.url) await handleNativeSupportUrl(launch.url);
}
